import { useTutorialMutation } from 'src/app/explore/use-tutorial';

export const SetUpYourProfile5Body = () => {
  return (
    <>
      <h1 className="text-2xl font-semibold text-gray-900 text-center mb-6">
        Build your Studio
      </h1>
      <img
        src="/images/assets/tutorial/set-up-your-profile-5.png"
        alt="set up your profile 5"
        className="w-full"
      />
    </>
  );
};

export const SetUpYourProfile5Footer = ({
  closeModal,
  completed,
}: {
  closeModal?: any;
  completed: boolean;
}) => {
  const { mutateAsync: updateTutorial } = useTutorialMutation();
  return (
    <>
      <h5 className="text-gray-900 font-medium text-center mb-3">
        Set up your profile
      </h5>
      <p
        className="text-sm font-normal text-gray-700 text-center mb-6"
        style={{ maxWidth: '608px' }}
      >
        The Business tab: Share your business with your audience, if you have
        one. It can be a great way to let people know that you offer
        professional services. Remember to save before moving on!
      </p>
      <button
        type="button"
        onClick={async () => {
          if (!completed) {
            await updateTutorial({ step: 'setup_profile' });
          }
          closeModal();
        }}
        className="px-9 py-2.5 mb-2 rounded-3xl bg-blue-500 font-semibold text-white"
      >
        Done
      </button>
      <h6 className="text-center text-blue-400 font-medium font-medium">
        5 / 5
      </h6>
    </>
  );
};
